/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'react-toastify/dist/ReactToastify.css';
import { ContentHeader } from 'C4';

import {
  CircularProgressbar,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

// TODO make work with API, grid sucks currently
// TODO open fancybox with train in academy
// Add app icon
// Add progress block
// Add start now / call to action all buttons
// Add xp unlock to all buttons
export default class SessionView extends Component {
  render() {
    return (
      <div className="sessionView">

        <div className="gradient" />
        <div className="bg" />

        <div className="breakoutHolder">
          <ContentHeader
            header="Training Sessions"
            subtitle="With our 15-minute modules, jump in and start your specialization for these destinations you can be selling to clients, especially now!"
            icon="dumbbell"
          />
          <div className="sessions">

            <div className="session">
              <div className="image__holder">
                <CircularProgressbar
                  value="75"
                  text="75%"
                  strokeWidth={5}
                  styles={buildStyles({
                    textColor: '#6cd488',
                    pathColor: '#6cd488',
                  })}
                />;
                <div className="overlay" />
                <img className="company__image" alt="user" src="https://front.travpromobile.com/source/universal/universal.jpg?fit=clamp&" />
              </div>
              <div className="content">
                <div className="time">
                  <FontAwesomeIcon icon={['fas', 'clock']} /> 16 minutes
                </div>
                <img className="app" alt="user" src="https://front.travpromobile.com/source/universal/icon.png?fit=clamp&" />
                <div className="titleHolder">
                  <span>Universal Studios</span>
                  <a
                    className="sub__copy"
                    data-fancybox="train"
                    data-type="iframe"
                    href="https://academy.travpromobile.com/training/290/chris@travpromobile.com/1275/0/true/false/"
                  >
                    Enroll Now &gt;
                  </a>
                </div>
              </div>
            </div>

            <ContentHeader
              header="Attractions"
              subtitle=""
              icon="dumbbell"
            />

            <div className="session">
              <div className="image__holder">
                <CircularProgressbar
                  value="35"
                  text="35%"
                  strokeWidth={5}
                  styles={buildStyles({
                textColor: '#6cd488',
                pathColor: '#6cd488',
              })}
                />;
                <div className="overlay" />
                <img className="company__image" alt="user" src="https://front.travpromobile.com/source/napa-valley/napa.jpg?fit=clamp&" />
              </div>
              <div className="content">
                <div className="time">
                  <FontAwesomeIcon icon={['fas', 'clock']} /> 17 minutes
                </div>
                <img className="app" alt="user" src="https://front.travpromobile.com/source/napa-valley/icon.png?fit=clamp&" />
                <div className="titleHolder">
                  <span>Napa Valley</span>
                  <a
                    className="sub__copy"
                    data-fancybox="train2"
                    data-type="iframe"
                    href="https://academy.travpromobile.com/training/290/chris@travpromobile.com/1275/0/true/false/"
                  >
                    Enroll Now &gt;
                  </a>
                </div>
              </div>
            </div>

						<div className="session">
              <div className="image__holder">
                <CircularProgressbar
                  value="55"
                  text="55%"
                  strokeWidth={5}
                  styles={buildStyles({
                  textColor: '#6cd488',
                  pathColor: '#6cd488',
                })}
                />;
                <div className="overlay" />
                <img className="company__image" alt="user" src="https://front.travpromobile.com/source/san-francisco/sanfran.jpg?fit=clamp&" />
              </div>
              <div className="content">
                <div className="time">
                  <FontAwesomeIcon icon={['fas', 'clock']} /> 15 minutes
                </div>
                <img className="app" alt="user" src="https://travpromobileimages.imgix.net/apptool/app/129/images/Icon-180.png?fit=clamp&" />
                <div className="titleHolder">
                  <span>San Francisco</span>
                  <a
                    className="sub__copy"
                    data-fancybox="train1"
                    data-type="iframe"
                    href="https://academy.travpromobile.com/training/290/chris@travpromobile.com/1275/0/true/false/"
                  >
                    Enroll Now &gt;
                  </a>
                </div>
              </div>
            </div>

            <ContentHeader
              header="CVBs"
              subtitle=""
              icon="dumbbell"
            />

            <div className="session">
              <div className="image__holder">
                <CircularProgressbar
                  value="60"
                  text="60%"
                  strokeWidth={5}
                  styles={buildStyles({
              textColor: '#6cd488',
              pathColor: '#6cd488',
            })}
                />;
                <div className="overlay" />
                <img className="company__image" alt="user" src="https://front.travpromobile.com/source/florida/florida.jpg?fit=clamp&" />
              </div>
              <div className="content">
                <div className="time">
                  <FontAwesomeIcon icon={['fas', 'clock']} /> 12 minutes
                </div>
                <img className="app" alt="user" src="https://front.travpromobile.com/source/florida/icon.png?fit=clamp&" />
                <div className="titleHolder">
                  <span>Florida</span>
                  <a
                    className="sub__copy"
                    data-fancybox="train3"
                    data-type="iframe"
                    href="https://academy.travpromobile.com/training/290/chris@travpromobile.com/1275/0/true/false/"
                  >
                    Enroll Now &gt;
                  </a>
                </div>
              </div>
            </div>

            <div className="session">
              <div className="image__holder">
                <CircularProgressbar
                  value="45"
                  text="45%"
                  strokeWidth={5}
                  styles={buildStyles({
            textColor: '#6cd488',
            pathColor: '#6cd488',
          })}
                />;
                <div className="overlay" />
                <img className="company__image" alt="user" src="https://front.travpromobile.com/source/houston/houston.jpg?fit=clamp&" />
              </div>
              <div className="content">
                <div className="time">
                  <FontAwesomeIcon icon={['fas', 'clock']} /> 14 minutes
                </div>
                <img className="app" alt="user" src="https://front.travpromobile.com/source/houston/icon.png?fit=clamp&" />
                <div className="titleHolder">
                  <span>Houston</span>
                  <a
                    className="sub__copy"
                    data-fancybox="train4"
                    data-type="iframe"
                    href="https://academy.travpromobile.com/training/290/chris@travpromobile.com/1275/0/true/false/"
                  >
                    Enroll Now &gt;
                  </a>
                </div>
              </div>
            </div>

						<ContentHeader
              header="Destinations"
              subtitle=""
              icon="dumbbell"
            />

          </div>
        </div>

        <div className="bottom__bar" />
      </div>
    );
  }
}
